import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import { type SupportZendeskTicketModel } from "@doitintl/cmp-models";
import { Chip, Link, Stack } from "@mui/material";

import ZendeskIcon from "../../assets/zendeskIcon.png";
import { useCustomerId } from "../../Components/hooks/useCustomerId";
import { useAuthContext } from "../../Context/AuthContext";
import SupportItemIcon from "../../Support/Components/SupportItemIcon";
import { getStatusColor } from "../../Support/Components/TicketsFilterTable/TicketsTableColumns";
import { transformStatus } from "../../utils/common";
import { useAvaDialogContext } from "./AvaDialogContextProvider";
import { openTicketInZendesk } from "./utils";

export const RecentTicketRow = ({ ticket }: { ticket: SupportZendeskTicketModel }) => {
  const customerId = useCustomerId();
  const { handleCloseAvaDialog } = useAvaDialogContext();

  const { isDoitEmployee } = useAuthContext();

  const { t } = useTranslation("services");

  if (!ticket.ticket) {
    return null;
  }
  const { id, status, subject, fields } = ticket.ticket;

  return (
    <Stack
      direction="row"
      spacing={1}
      flex={1}
      alignSelf="flex-start"
      sx={{ borderBottom: "1px solid", borderColor: "divider", py: 2 }}
      alignItems="center"
      justifyContent="space-between"
    >
      <Stack direction="row" spacing={1}>
        {isDoitEmployee ? (
          <Link
            href="#"
            onClick={() => {
              openTicketInZendesk(Number(id));
            }}
            data-cy={`ticketRow-${id}-zendDesk`}
          >
            <img alt="zendesk icon" style={{ width: 20, height: 20 }} src={ZendeskIcon} />
          </Link>
        ) : (
          <SupportItemIcon platformValue={fields.Platform} />
        )}
        <Link
          color="inherit"
          component={RouterLink}
          to={`/customers/${customerId}/support/tickets/${id}`}
          underline="always"
          variant="body2"
          onClick={handleCloseAvaDialog}
          sx={{ mr: 1 }}
        >
          {id}
        </Link>
        <Link
          color="inherit"
          component={RouterLink}
          to={`/customers/${customerId}/support/tickets/${id}`}
          underline="always"
          variant="body2"
          onClick={handleCloseAvaDialog}
        >
          {subject}
        </Link>
      </Stack>
      <Chip variant="status" color={getStatusColor(status)} label={transformStatus(status, t)} />
    </Stack>
  );
};
